import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from './actions';

class PlayerTeamStackingAllPlayersSwitcher extends Component {
    onCheck(isChecked) {
        const {players} = this.props;
        const playerIds = players.map((player) => player.playerId);

        this.props.dispatch(Action.set('UsageOfPlayersOnlyInTeamStacking', {playerIds, isChecked}));
    }

    areAllChecked() {
        const {nchsPlayers, players} = this.props;

        for (let player of players) {
            if (!nchsPlayers.isOnlyInTeamStackingUsed(player.getId())) {
                return false;
            }
        }

        return true;
    }

    render() {
        const {className = '', label} = this.props;
        const isChecked = this.areAllChecked();

        if (label) {
            return (
                <div className="label-block" onClick={() => ::this.onCheck(!isChecked)}>
                    <button
                        className={isChecked ? `${className} active` : className}
                        title={isChecked ? 'Chain to Stacking enabled' : 'Chain to Stacking disabled'}
                    >
                        {isChecked ? 'Chain to Stacking enabled' : 'Chain to Stacking disabled'}
                    </button>
                    <span className="label-block-text">{label}</span>
                </div>
            );
        }

        return (
            <button
                className={isChecked ? `${className} active` : className}
                onClick={() => ::this.onCheck(!isChecked)}
                title={isChecked ? 'Chain to Stacking enabled' : 'Chain to Stacking disabled'}
            >
                {isChecked ? 'Chain to Stacking enabled' : 'Chain to Stacking disabled'}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {nonControlledHitterStacking} = state;

    return {
        nchsPlayers: nonControlledHitterStacking.players,
    };
}

export default connect(mapStatesToProps)(PlayerTeamStackingAllPlayersSwitcher);
